import { memo } from 'react'
import { X, AlertTriangle, CheckCircle, Info } from 'lucide-react'
import { useToast } from '../context/useToast'

const ICONS = {
  error:   <AlertTriangle className="w-4 h-4 shrink-0 text-risk-red"   aria-hidden />,
  success: <CheckCircle   className="w-4 h-4 shrink-0 text-risk-green" aria-hidden />,
  info:    <Info          className="w-4 h-4 shrink-0 text-gold"        aria-hidden />,
}

const BORDER_COLOR = {
  error:   'var(--color-risk-red)',
  success: 'var(--color-risk-green)',
  info:    'var(--color-gold)',
}

export default memo(function ToastContainer() {
  const { toasts, dismiss } = useToast()

  if (!toasts.length) return null

  return (
    <div
      aria-live="polite"
      aria-label="Notifications"
      className="toast-contain fixed bottom-6 right-6 z-[9999] flex flex-col gap-2.5 pointer-events-none"
    >
      {toasts.map(toast => (
        <div
          key={toast.id}
          role="status"
          style={{
            borderLeftWidth: '4px',
            borderLeftColor: BORDER_COLOR[toast.type],
          }}
          className="pointer-events-auto flex items-start gap-3 bg-navy-card border border-slate-border rounded-xl shadow-lg shadow-black/8 px-4 py-3 max-w-sm w-full animate-toast-in"
        >
          {ICONS[toast.type]}
          <p className="text-sm text-cream leading-snug flex-1 m-0 max-w-none">
            {toast.message}
          </p>
          <button
            onClick={() => dismiss(toast.id)}
            aria-label="Dismiss notification"
            className="shrink-0 text-sepia hover:text-parchment/70 bg-transparent border-0 cursor-pointer p-0 leading-none mt-0.5 transition-colors"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      ))}
    </div>
  )
})
